<template>
	<div class="">
		<div class="information" v-show="formShow">
			<div class="information_div">
				<div class="information_div_div">
					<img class="img_gr" src="../assets/personal.png" />
				</div>
				<input ref="inputFocus" v-model="group_user" type="" name="" placeholder="账户名（只能包含字母或数字3~18位）" id="" value="" />
			</div>
			<div class="information_div">
				<div class="information_div_div">
					<img class="img_sjh" src="../assets/group_pass.png" />
				</div>
				<input ref="inputFocus" v-model="group_pass" type="password" name="" id="" placeholder="请使用数字、大小写字母，特殊字符中3种组合成8-16位密码" value="" />
			</div>
			<div class="information_div">
				<div class="information_div_div">
					<img class="img_sjh" src="../assets/group_pass.png" />
				</div>
				<input ref="inputFocus" v-model="group_passYes" type="password" name="" id="" placeholder="请确认密码" value="" />
			</div>
			<div class="information_div">
				<div class="information_div_div">
					<img class="img_sfz" src="../assets/teamName.png" />
				</div>
				<input ref="inputFocus" v-model="teamName" type="" name="" id="" placeholder="请填写单位名称" value="" />
			</div>
			<div class="information_div" v-if="test=='false'">
				<div class="information_div_div">
					<img class="img_sfz" src="../assets/teamName.png" />
				</div>
				<van-field v-model="address" readonly clickable label="" :value="value" placeholder="选择所在地址" @click="showPicker = true" />
				<van-popup v-model="showPicker" position="bottom">
					<van-area :area-list="areaList" :columns-placeholder="['请选择', '请选择', '请选择']" @cancel="showPicker = false" @confirm="onConfirm" />
				</van-popup>
			</div>
			<div class="information_div">
				<div class="information_div_div">
					<img class="img_gr" src="../assets/personal.png" />
				</div>
				<input ref="inputFocus" v-model="group_name" type="" name="" placeholder="请填写领队人姓名" id="" value="" />
			</div>

			<div class="information_div">
				<div class="information_div_div">
					<img class="img_sfz" src="../assets/sfz.png" />
				</div>
				<input ref="inputFocus" v-model="group_id" type="" name="" placeholder="请填写领队人身份证号" id="" value="" />
			</div>

			<div class="information_div">
				<div class="information_div_div">
					<img class="img_sjh" src="../assets/sjh.png" />
				</div>
				<input ref="inputFocus" v-model="group_phone" maxlength="11" type="" name="" placeholder="请填写领队人手机号" id="" value="" />
			</div>
			<div class="information_div" v-if="qita">
				<div class="information_div_div">
					<img class="img_sfz" src="../assets/businessIdNum.png" />
				</div>
				<input ref="inputFocus" v-model="businessIdNum" type="" name="" id="" placeholder="请填写单位营业资质编号" value="" />
			</div>
		</div>
		<div class="certificate" v-if="qita" v-show="formShow">上传营业执照：</div>
		<div class="inp_file file_qita" v-if="qita" v-show="formShow">
			<div v-if="fill_img_two" class="file" v-show="true">
				<div class="file_img">
					<img :src="fill_img_two" />
				</div>
				<input type="file" name="" id="" value="" />
				<div class="file_no" @click="Delete_two">
					<img src="../assets/file_no.png" />
				</div>
			</div>
			<div v-else="" class="file" v-show="false">
				<div class="file_img">
					<img src="../assets/file_one.png" />
				</div>
				<input type="file" name="" id="" value="" />
				<div class="file_no" @click="Delete_two">
					<img src="../assets/file_no.png" />
				</div>
			</div>
			<div class="file">
				<div class="file_img">
					<img src="../assets/file_one.png" />
				</div>
				<form id="uploadForm_two" enctype="multipart/form-data">
					<input id="upload2" accept="image/*" type="file" name="upload" multiple="multiple" v-on:change="uploadFile_two()" />
					<!--<button name="upload1" id="upload1" type="button" onclick="uploadFile()">upload</button>-->
				</form>
			</div>
		</div>
		<div class="certificate" v-if="danwei">上传介绍信：</div>
		<div class="inp_file" v-if="danwei">
			<div v-for="(item,index) in license" class="file">
				<div class="file_img">
					<img :src="item.imageurl" />
				</div>
				<div class="file_no" @click="Delete(item,index)">
					<img src="../assets/file_no.png" />
				</div>
			</div>
			<div class="file">
				<div class="file_img">
					<img src="../assets/file_one.png" />
				</div>
				<form id="uploadForm" enctype="multipart/form-data">
					<input id="upload2" accept="image/*" type="file" name="upload" multiple="multiple" v-on:change="uploadFile()" />
					<!--<button name="upload1" id="upload1" type="button" onclick="uploadFile()">upload</button>-->
				</form>
			</div>
		</div>
		<div class="agreement" v-show="formShow">
			<img v-if="agreement_img" src="../assets/gou_yes.png" @click="agreement_cli" />
			<img v-else="" src="../assets/gou_no.png" @click="agreement_cli" />
			<div>同意革命纪念馆
				<a>用户协议</a> 与
				<a>隐私政策</a>
			</div>
		</div>
		<div class="buttom_bcone" @click="buttombc" v-show="formShow">
			保存
		</div>
		<div class="yin_ts" v-if="yin">
			<div class="buttom_x"><img src="../assets/buttom_x.png" /></div>
			<div class="text">{{yin_text}}</div>
			<div class="buttom_text" @click="modify">去修改</div>
		</div>
		<div class='view_yinyin' v-if="yin" catchtouchmove="return" @click="modify"></div>
		<div v-if="test=='true'" class="submission" v-show="submission">
			<div class="sub_text">
				<div>团队账号注册成功</div>
				<div @click="toLand">去预约</div>
			</div>
		</div>
		<div v-if="test=='false'" class="submission" v-show="submission">
			<div class="sub_text">
				<div>您的团队注册申请已提交, <br>请耐心等待审核结果.</div>
				<div @click="toLand">返回首页</div>
			</div>
		</div>
		<div class="companyType" v-show="companyTypeShow">
			<div class="companyType_title">请选择机构类型：</div>
			<div class="companyType_content">
				<div :class="companyIndex==index?'companyType_content_list_cli':'companyType_content_list'" @click="companyClick(item,index)" v-for="(item,index) in companyType">{{item.type}}</div>
			</div>
			<div class="fill_btn_bottom">
				<div class="fill_btn" @click="companyType_btn">
					确定
				</div>
			</div>
		</div>
	</div>

</template>

<script>
	import { wclient } from '../../static/wclient-mobile.js'
	import areaList from '../../static/area.js'

	export default {
		name: 'GroupRegistration',
		data() {
			return {
				group_documentType: "请选择证件类型",
				group_name: "",
				group_phone: "",
				group_id: "",
				group_pass: "",
				group_passYes: "",
				yin: false,
				yin_text: "",
				name_reg: "",
				IdNumber_reg: "",
				baseUrl: "",
				teamName: "",
				businessIdNum: "",
				agreement_img: false,
				base64: "",
				imgUrlFromServer: "",
				fill_img: "",
				fill_img_two: "",
				group_user: "",
				submission: false,
				certificateType: "idcard",
				formShow: false,
				companyType: [{
					'type': '事业单位'
				}, {
					'type': '企业单位'
				}, {
					'type': '学校'
				}, {
					'type': '政府机关'
				}, {
					'type': '旅行社'
				}],
				companyIndex: -1,
				companyName: "",
				companyTypeShow: true,
				teamType: "",
				qita: false,
				danwei: false,
				license: [],
				phoneReg: "",
				baseUrlOne: "",
				userReg: "",
				unit_reg: "",
				test: 'false',
				areaList,
				searchResult: [],
				value: '',
				showPicker: false,
				address: ""
			}
		},
		methods: {
			onConfirm(value) {
				console.log(value)
				if(value[0].name == '') {
					this.showPicker = false;
				} else if(value[1].name == '' || value[2].name == '') {
					this.yin = true;
					this.yin_text = '请补充所在地址';
				} else {
					this.showPicker = false;
					this.address = value[0].name + '-' + value[1].name + '-' + value[2].name;
				}
			},
			companyClick(item, index) {
				var that = this;
				that.companyIndex = index;
				that.companyName = item.type;
			},
			companyType_btn() {
				var that = this;
				if(that.companyName == "") {
					that.yin = true;
					that.yin_text = '请选择机构类型';
				} else if(that.companyName == "旅行社") {
					that.companyTypeShow = false;
					that.formShow = true;
					that.teamType = 5;
					that.qita = true;
					that.danwei = false;
				} else if(that.companyName == "政府机关") {
					that.companyTypeShow = false;
					that.formShow = true;
					that.teamType = 4;
					that.qita = false;
					that.danwei = true;
				} else if(that.companyName == "学校") {
					that.companyTypeShow = false;
					that.formShow = true;
					that.teamType = 3;
					that.qita = false;
					that.danwei = true;
				} else if(that.companyName == "企业单位") {
					that.companyTypeShow = false;
					that.formShow = true;
					that.teamType = 2;
					that.qita = false;
					that.danwei = true;
				} else if(that.companyName == "事业单位") {
					that.companyTypeShow = false;
					that.formShow = true;
					that.teamType = 1;
					that.qita = false;
					that.danwei = true;
				}
			},
			getFocus() {    
				$("input").on("blur", function() {        
					window.scroll(0, 0);    
				});
			},
			validIdCard(value) {
				var arrExp = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2]; //加权因子 
				var arrValid = [1, 0, "X", 9, 8, 7, 6, 5, 4, 3, 2]; //校验码 
				if (/^\d{17}\d|x$/i.test(value)) {
					var sum = 0,
						idx;
					for (var i = 0; i < value.length - 1; i++) {
						// 对前17位数字与权值乘积求和 
						sum += parseInt(value.substr(i, 1), 10) * arrExp[i];
					}
					// 计算模（固定算法） 
					idx = sum % 11;
					// 检验第18为是否与校验码相等 
					return arrValid[idx] == value.substr(17, 1).toUpperCase();
				} else {
					return false;
				}
			},
			buttombc() {
				var that = this;
				that.name_reg = /^[\u4E00-\u9FA5\uf900-\ufa2d·s]{2,20}$/;
				that.phoneReg = /^1[3456789]\d{9}$/;
				that.userReg = /^[a-zA-Z0-9]+$/;
				that.unit_reg = /^[\u4e00-\u9fa5a-zA-Z]{2,30}$/;
				that.IdNumber_reg = /^(^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$)|(^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])((\d{4})|\d{3}[Xx])$)$/;
				var pass_reg = /^[a-zA-Z0-9]+$/;
				var reg = /^(((?=.*[a-z])+(?=.*[A-Z])+(?=.*\d)+)|((?=.*[A-Z])+(?=.*[a-z])+(?=.*[`~!@#$%^&*()+={}':;',.<>?~！@#￥%……&*（）——+{}【】‘；：”“’。，、？\|])+)|((?=.*\d)+(?=.*[A-Z])+(?=.*[`~!@#$%^&*()+={}':;',.<>?~！@#￥%……&*（）——+{}【】‘；：”“’。，、？\|])+)|((?=.*\d)+(?=.*[a-z])+(?=.*[`~!@#$%^&*()+={}':;',.<>?~！@#￥%……&*（）——+{}【】‘；：”“’。，、？\|])+))[A-Za-z\d`~!@#$%^&*()+={}':;',.<>?~！@#￥%……&*（）——+{}【】‘；：”“’。，、？\|]{8,20}$/;
				if(that.teamType == '5') {
					if(that.group_user == "") {
						that.yin = true;
						that.yin_text = '请输入账户名';
					} else if(that.group_user.length < 3 || that.group_user.length > 18) {
						that.yin = true;
						that.yin_text = '请输入3~18位账户名（不包含特殊字符、汉字）';
					} else if(!that.userReg.test(that.group_user)) {
						that.yin = true;
						that.yin_text = '账户名格式错误（不包含特殊字符、汉字）';
					} else if(that.group_pass == "") {
						that.yin = true;
						that.yin_text = '请填写密码';
					} else if(!reg.test(that.group_pass)) {
						that.yin = true;
						that.yin_text = '请使用数字、大小写字母，特殊字符中3种组合成8-16位密码';
					} else if(that.group_passYes == "" && that.group_passYes != that.group_pass) {
						that.yin = true;
						that.yin_text = '两次密码不一致';
					} else if(that.teamName == "") {
						that.yin = true;
						that.yin_text = '请填写单位名称';
					} else if(!that.unit_reg.test(that.teamName)) {
						that.yin = true;
						that.yin_text = '请输入正确的单位名称，只能包含字母汉字，2-30位';
					} else if(that.test == 'false' && that.address == '') {
						that.yin = true;
						that.yin_text = '请选择所在地址';
					} else if(!that.name_reg.test(that.group_name)) {
						that.yin = true;
						that.yin_text = '姓名认证错误';
					} else if(!that.validIdCard(that.group_id)) {
						that.yin = true;
						that.yin_text = '请输入正确的18位身份证号（不包含特殊字符、汉字,X需大写）';
					} else if(!that.phoneReg.test(that.group_phone)) {
						that.yin = true;
						that.yin_text = '手机号认证错误';
					} else if(that.businessIdNum == "") {
						that.yin = true;
						that.yin_text = '请填写经营证书编号';
					} else if(that.fill_img_two == '') {
						that.yin = true;
						that.yin_text = '请上传营业执照';
					} else if(that.agreement_img == false) {
						that.yin = true;
						that.yin_text = '请签订用户协议';
					} else {
						if(that.test == 'false') {
							wclient.view.showLoading();
							wclient.crossdomain = true; // 启动跨域支持（多模块组合应用）
							wclient.ajax({
								type: "POST",
								url: that.baseUrlOne + "/tickets/tickets/ajax?ugi=userUgi&action=createTeamAccount",
								dataType: "json",
								async: true,
								data: {
									realName: that.group_name,
									accountName: that.group_user,
									certificateType: that.certificateType,
									phone: that.group_phone,
									idNumber: that.group_id,
									password: that.group_pass,
									confirmPassword: that.group_passYes,
									teamName: that.teamName,
									businessIdNum: that.businessIdNum,
									businessScanCopy: that.fill_img_two,
									teamType: parseInt(that.teamType),
									address: that.address
								},
								success: function(data) {
									wclient.view.hideLoading();
									if(data.code == "A00006") {
										that.submission = true;
									}else if(data.code == "A00001"){
										that.yin = true;
										that.yin_text = '系统繁忙，请稍后再试';
									} else {
										that.yin = true;
										that.yin_text = data.errmsg;
									}
								}
							});
						} else if(that.test == 'true') {
							wclient.view.showLoading();
							wclient.crossdomain = true; // 启动跨域支持（多模块组合应用）
							wclient.ajax({
								type: "POST",
								url: that.baseUrlOne + "/tickets/tickets/ajax?ugi=userUgi&action=createTeamAccount",
								dataType: "json",
								async: true,
								data: {
									realName: that.group_name,
									accountName: that.group_user,
									certificateType: that.certificateType,
									phone: that.group_phone,
									idNumber: that.group_id,
									password: that.group_pass,
									confirmPassword: that.group_passYes,
									teamName: that.teamName,
									businessIdNum: that.businessIdNum,
									businessScanCopy: that.fill_img_two,
									teamType: parseInt(that.teamType)
								},
								success: function(data) {
									wclient.view.hideLoading();
									if(data.code == "A00006") {
										that.submission = true;
									}else if(data.code == "A00001"){
										that.yin = true;
										that.yin_text = '系统繁忙，请稍后再试';
									} else {
										that.yin = true;
										that.yin_text = data.errmsg;
									}
								}
							});
						}

					}
				} else {
					if(that.group_user == "") {
						that.yin = true;
						that.yin_text = '请输入账户名';
					} else if(that.group_user.length < 3 || that.group_user.length > 18) {
						that.yin = true;
						that.yin_text = '请输入3~18位账户名（不包含特殊字符、汉字）';
					} else if(!that.userReg.test(that.group_user)) {
						that.yin = true;
						that.yin_text = '账户名格式错误（不包含特殊字符、汉字）';
					} else if(that.group_pass == "") {
						that.yin = true;
						that.yin_text = '请填写密码';
					}  else if(!reg.test(that.group_pass)) {
						that.yin = true;
						that.yin_text = '请使用数字、大小写字母，特殊字符中3种组合成8-16位密码';
					} else if(that.group_passYes == "" && that.group_passYes != that.group_pass) {
						that.yin = true;
						that.yin_text = '两次密码不一致';
					} else if(that.teamName == "") {
						that.yin = true;
						that.yin_text = '请填写单位名称';
					} else if(!that.unit_reg.test(that.teamName)) {
						that.yin = true;
						that.yin_text = '请输入正确的单位名称，只能包含字母汉字，2-30位';
					} else if(that.test == 'false' && that.address == '') {
						that.yin = true;
						that.yin_text = '请选择所在地址';
					} else if(!that.name_reg.test(that.group_name)) {
						that.yin = true;
						that.yin_text = '姓名认证错误';
					} else if(!that.validIdCard(that.group_id)) {
						that.yin = true;
						that.yin_text = '请输入正确的18位身份证号（不包含特殊字符、汉字,X需大写）';
					} else if(!that.phoneReg.test(that.group_phone)) {
						that.yin = true;
						that.yin_text = '手机号认证错误';
					} else if(that.fill_img == '') {
						that.yin = true;
						that.yin_text = '请上传介绍信';
					} else if(that.agreement_img == false) {
						that.yin = true;
						that.yin_text = '请签订用户协议';
					} else {
						if(that.test == 'false') {
							wclient.view.showLoading();
							wclient.crossdomain = true; // 启动跨域支持（多模块组合应用）
							wclient.ajax({
								type: "POST",
								url: that.baseUrlOne + "/tickets/tickets/ajax?ugi=userUgi&action=createTeamAccount",
								dataType: "json",
								async: true,
								data: {
									realName: that.group_name,
									accountName: that.group_user,
									certificateType: that.certificateType,
									phone: that.group_phone,
									idNumber: that.group_id,
									password: that.group_pass,
									confirmPassword: that.group_passYes,
									teamName: that.teamName,
									teamType: parseInt(that.teamType),
									license: JSON.stringify(that.license),
									address:that.address
								},
								success: function(data) {
									wclient.view.hideLoading();
									if(data.code == "A00006") {
										that.submission = true;
									}else if(data.code == "A00001"){
										that.yin = true;
										that.yin_text = '系统繁忙，请稍后再试';
									} else {
										that.yin = true;
										that.yin_text = data.errmsg;
									}
								}
							});
						} else if(that.test == 'true') {
							wclient.view.showLoading();
							wclient.crossdomain = true; // 启动跨域支持（多模块组合应用）
							wclient.ajax({
								type: "POST",
								url: that.baseUrlOne + "/tickets/tickets/ajax?ugi=userUgi&action=createTeamAccount",
								dataType: "json",
								async: true,
								data: {
									realName: that.group_name,
									accountName: that.group_user,
									certificateType: that.certificateType,
									phone: that.group_phone,
									idNumber: that.group_id,
									password: that.group_pass,
									confirmPassword: that.group_passYes,
									teamName: that.teamName,
									teamType: parseInt(that.teamType),
									license: JSON.stringify(that.license)
								},
								success: function(data) {
									wclient.view.hideLoading();
									if(data.code == "A00006") {
										that.submission = true;
									}else if(data.code == "A00001"){
										that.yin = true;
										that.yin_text = '系统繁忙，请稍后再试';
									} else {
										that.yin = true;
										that.yin_text = data.errmsg;
									}
								}
							});
						}
					}
				}

			},
			modify() {
				var that = this;
				that.yin = false;
			},
			modify() {
				var that = this;
				that.yin = false;
			},
			uploadFile() {
				var that = this;
				wclient.view.showLoading();
				$.ajax({
					url: that.baseUrl + '/account/upload/image/uploads',
					type: 'POST',
					cache: false,
					data: new FormData($('#uploadForm')[0]),
					processData: false,
					contentType: false
				}).done(function(res) {
					var data = $.parseJSON(res);
					wclient.view.hideLoading();
					if(data.code == 'A00006') {
						if(data.imageurl.length == 1) {
							that.fill_img = data.imageurl[0].imageurl;
							if(that.license.length > 2) {
								that.yin = true;
								that.yin_text = '图片最多上传三张';
							} else {
								that.license.push({
									"imageid": "cd68da094293489b8e9785af87689681",
									"imageurl": that.fill_img
								});
							}
						} else {
							if(data.imageurl.length > 2) {
								that.yin = true;
								that.yin_text = '图片最多上传三张';
							} else {
								that.license = data.imageurl;
							}
						}
					} else {
						that.yin = true;
						that.yin_text = '请上传jpg,jpeg,png格式的图片';
					}

				}).fail(function(res) {});
			},
			Delete(item, index) {
				var that = this;
				that.license.splice(index, 1)
			},
			Delete_two() {
				var that = this;
				that.fill_img_two = ""
			},
			uploadFile_two() {
				var that = this;
				wclient.view.showLoading();
				$.ajax({
					url: that.baseUrl + '/account/upload/image/uploads',
					type: 'POST',
					cache: false,
					data: new FormData($('#uploadForm_two')[0]),
					processData: false,
					contentType: false
				}).done(function(res) {
					var data = $.parseJSON(res);
					wclient.view.hideLoading();
					if(data.code == 'A00006') {
						that.fill_img_two = data.imageurl[0].imageurl;
					} else {
						that.yin = true;
						that.yin_text = '请上传jpg,jpeg,png格式的图片';
					}
				}).fail(function(res) {});
			},
			agreement_cli() {
				var that = this;
				that.agreement_img = !that.agreement_img;
			},
			toLand() {
				var that = this;
				if(that.test == 'true') {
					$.ajax({
						type: "post",
						url: that.baseUrlOne + "/tickets/tickets/ajax?ugi=loginUgi&action=teamLogin",
						async: true,
						data: {
							accountName: that.group_user,
							password: that.group_passYes
						},
						dataType: 'jsonp',
						crossDomain: true,
						xhrFields: {
							withCredentials: true
						},
						success: function(res) {
							console.log(res)
							if(res.code == 'A00006') {
								that.$router.push({
									name: 'Logo'
								});
							} else {
								that.success = true;
								that.success_img = false;
								that.success_text = res.errmsg
							}
						}
					});
				} else if(that.test == 'false') {
					that.$router.push({
						name: 'Logo'
					});
				}

			}
		},
		mounted() {
			var that = this;
			var publicUrl = window.location.hostname;
			if(publicUrl == "localhost") {
				var baseUrl = "http://xs.weapi.org";
				var baseUrlOne = "http://tickets.xs.weapi.org";
				that.test = 'false';
			} else if(publicUrl == "m.xs.weapi.org") {
				var baseUrl = "http://xs.weapi.org";
				var baseUrlOne = "http://tickets.xs.weapi.org";
				that.test = 'false';
			} else {
				var baseUrl = "https://www.xiangshan1949.cn";
				var baseUrlOne = "https://www.xiangshan1949.cn";
				that.test = 'true';
			}
			that.baseUrl = baseUrl;
			that.baseUrlOne = baseUrlOne;
		}
	}
</script>

<style scoped>
	body {
		width: 100%;
		background: #eee;
		overflow: hidden;
	}
	
	.information {
		width: 82%;
		background: #fff;
		border-radius: 15px;
		overflow: hidden;
		padding: 0 5%;
		margin-left: 4%;
		-webkit-overflow-scrolling: touch;
		margin-top: 15px;
	}
	
	.img_gr {
		width: 22px;
	}
	
	.img_sfz {
		width: 22px;
	}
	
	.img_sjh {
		width: 16px;
	}
	
	.information_div {
		display: flex;
		border-bottom: 1px #eee solid;
		align-items: center;
		justify-content: space-between;
	}
	
	.information_div_div {
		width: 30px;
		display: flex;
		align-items: center;
		justify-content: center;
	}
	
	input {
		border: none;
		outline: none;
		line-height: 60px;
		font-size: 16px;
		width: 85%;
	}
	
	select {
		-webkit-appearance: none;
		-moz-appearance: none;
		appearance: none;
		border: none;
		outline: none;
		font-size: 16px;
		color: #B1B1B1;
		width: 72%;
		background: white !important;
	}
	
	.information_div>img {
		width: 5%;
	}
	
	.buttom_bcone {
		width: 60%;
		background: linear-gradient(255deg, rgba(228, 4, 4, 1), rgba(255, 56, 56, 1));
		line-height: 39px;
		border-radius: 48px;
		text-align: center;
		color: #fff;
		font-size: 15px;
		margin: 0 20% 20px;
	}
	
	.certificate {
		width: 90%;
		margin-left: 5%;
		margin-top: 20px;
		font-weight: 600;
		color: rgba(0, 0, 0, 1);
		opacity: 0.66;
		font-size: 16px;
	}
	
	.inp_file {
		width: 90%;
		margin: 0 5%;
		display: flex;
		justify-content: flex-start;
		margin-bottom: 20px;
		flex-wrap: wrap;
	}
	
	.file {
		float: left;
		position: relative;
		width: 30%;
		height: 100px;
		margin-top: 10px;
		margin-right: 10px;
	}
	
	.file_img {
		float: left;
		width: 100%;
		height: 100%;
		border-radius: 10px;
	}
	
	.file input {
		position: absolute;
		width: 100%;
		height: 100%;
		left: 0px;
		top: 0px;
		opacity: 0;
		-ms-filter: 'alpha(opacity=0)';
	}
	
	.file_no {
		position: absolute;
		top: -8px;
		right: -8px;
		width: 25px;
		height: 25px;
		border-radius: 50%;
		box-shadow: 0px 1px 7px 2px rgba(154, 154, 154, 0.2);
		color: #9A9A9A;
		background: rgb(252, 245, 247);
	}
	
	.agreement {
		width: 100%;
		font-size: 13px;
		color: #7F7F7F;
		display: flex;
		justify-content: center;
		margin-bottom: 20px;
	}
	
	.agreement a {
		color: #92C0FF;
	}
	
	.agreement div {
		float: left;
	}
	
	.agreement img {
		width: 5%;
		margin-right: 1%;
		margin-top: -1px;
	}
	
	.view_yinyin {
		width: 100vh;
		height: 100vh;
		background: rgba(0, 0, 0, .3);
		position: fixed;
		top: 0;
		overflow: hidden;
		z-index: 998;
	}
	
	.yin_ts {
		position: fixed;
		top: 25%;
		background: #fff;
		z-index: 999;
		border-radius: 20px;
		width: 66%;
		left: 17%;
		text-align: center;
	}
	
	.buttom_x {
		display: flex;
		justify-content: center;
		align-items: center;
		margin: 30px 0;
	}
	
	.buttom_x img {
		width: 60px;
	}
	
	.text {
		font-size: 17px;
		font-family: PingFangSC-Medium;
		font-weight: 600;
		color: rgba(55, 55, 55, 1);
		width: 80%;
		margin: 0 auto;
	}
	
	.title {
		font-weight: 400;
		color: rgba(164, 164, 164, 1);
		font-size: 16px;
		line-height: 30px;
		border-bottom: 1px rgb(225, 225, 225) solid;
		padding-bottom: 10px;
	}
	
	.buttom_text {
		color: rgba(228, 4, 4, 1);
		line-height: 50px;
		font-size: 16px;
		font-weight: bold;
		border-top: 1px solid #eee;
		margin-top: 20px;
	}
	
	.submission {
		position: fixed;
		top: 0;
		left: 0;
		width: 100%;
		height: 100vh;
		background: rgba(0, 0, 0, 0.5);
	}
	
	.sub_text {
		width: 64%;
		margin: 34vh auto 0;
		background: white;
		border-radius: 10px;
	}
	
	.sub_text div:nth-child(1) {
		text-align: center;
		width: 90%;
		padding: 25px 5%;
		font-weight: 400;
	}
	
	.sub_text div:nth-child(2) {
		text-align: center;
		width: 100%;
		font-weight: 400;
		line-height: 40px;
		border-top: 1px solid #CDCDCD;
		color: rgba(207, 18, 14, 1);
	}
	
	.companyType {
		width: 92%;
		margin: 20px auto;
		background: white;
		border-radius: 20px;
		padding-top: 10px;
		padding-bottom: 10px;
	}
	
	.companyType_title {
		width: 90%;
		margin: 10px auto;
		font-size: 18px;
	}
	
	.companyType_content {
		width: 90%;
		margin: 0 auto;
		display: flex;
		justify-content: space-between;
		flex-wrap: wrap;
	}
	
	.companyType_content_list {
		width: 45%;
		text-align: center;
		line-height: 50px;
		background: linear-gradient(255deg, rgba(228, 4, 4, 0.3), rgba(255, 56, 56, 0.6));
		color: white;
		margin-bottom: 20px;
		font-size: 16px;
		border-radius: 10px;
	}
	
	.companyType_content_list_cli {
		width: 45%;
		text-align: center;
		line-height: 50px;
		background: linear-gradient(255deg, rgba(228, 4, 4, 1), rgba(255, 56, 56, 1));
		color: white;
		margin-bottom: 20px;
		font-size: 16px;
		border-radius: 10px;
		opacity: 1;
	}
	
	.fill_btn_bottom {
		width: 100%;
		position: fixed;
		bottom: 0;
		left: 0;
		background: white;
	}
	
	.fill_btn {
		margin: 10px auto;
		width: 70%;
		background: linear-gradient(255deg, rgba(228, 4, 4, 1), rgba(255, 56, 56, 1));
		border-radius: 40px;
		color: rgba(254, 254, 254, 1);
		line-height: 45px;
		text-align: center;
		font-size: 14px;
	}
	
	>>>.van-cell {
		padding: 0;
		width: 87%;
	}
	
	>>>.van-field__label {
		display: none !important;
	}
	
	>>>.van-field__control {
		font-size: 16px;
		border: none;
		text-indent: 6px;
	}
	
	>>>.van-overlay {
		z-index: 996 !important;
	}
	
	>>>.van-popup {
		z-index: 997 !important;
	}
	>>>.van-field__body{
		line-height: 60px;
		color: #b1b1b1;
	}
</style>


// WEBPACK FOOTER //
// src/components/groupRegistration.vue